if (!customElements.get('er-size-guide')) {
  customElements.define('er-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.dialog = this.querySelector('[data-er-guide-dialog]');
      this.trigger = this.querySelector('[data-er-guide-open]');
      if (!this.dialog || !this.trigger || typeof this.dialog.showModal !== 'function') return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.trigger.hidden = false;
      this.trigger.addEventListener('click', () => this.open(), options);
      this.querySelector('[data-er-guide-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
      }, options);
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => this.updateOverflow());
        this.observer.observe(this.dialog);
      }
    }

    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
    }

    open() {
      if (this.dialog.open) return;
      this.previousFocus = document.activeElement;
      this.highlightSize();
      this.dialog.showModal();
      this.dialog.querySelector('.er-size-guide__body').scrollTop = 0;
      this.dialog.querySelectorAll('.er-size-guide__table-wrap').forEach((table) => { table.scrollLeft = 0; });
      this.updateOverflow();
    }

    highlightSize() {
      const product = this.closest('er-product');
      const field = this.closest('[data-er-size-field]');
      const index = Number(this.dataset.sizeOptionIndex);
      let selected = '';
      if (product && index >= 0) {
        selected = product.variant?.options?.[index] || '';
        if (!product.initialized) selected = field?.querySelector('input:checked')?.value || '';
      } else if (field) {
        const select = field.querySelector('select');
        selected = field.querySelector('input:checked')?.value || select?.value || '';
      }
      const normalise = (value) => String(value).trim().toLocaleLowerCase();
      this.querySelectorAll('[data-er-guide-size]').forEach((row) => {
        const active = selected !== '' && normalise(row.dataset.erGuideSize) === normalise(selected);
        row.classList.toggle('is-selected', active);
        if (active) row.setAttribute('aria-current', 'true');
        else row.removeAttribute('aria-current');
      });
    }

    updateOverflow() {
      if (!this.dialog?.open) return;
      const table = this.querySelector('[data-er-guide-table-wrap]');
      const hint = this.querySelector('[data-er-guide-scroll-hint]');
      if (table && hint) hint.hidden = table.scrollWidth <= table.clientWidth + 1;
    }
  });
}
